if ( typeof VariantGallery !== 'function' ) {

	class VariantGallery extends HTMLElement {

		constructor(){
			super();

			this.track = this.querySelector('[data-variant-gallery-track]');
			this.prevBtn = this.querySelector('[data-variant-gallery-prev]');
			this.nextBtn = this.querySelector('[data-variant-gallery-next]');
			this.currentVariantId = this.dataset.activeVariant || null;

			// Parse variant-to-image-holder map
			const mapEl = this.querySelector('script[data-variant-image-map]');
			this.variantMap = mapEl ? JSON.parse(mapEl.textContent) : {};

			// Arrow click handlers
			if ( this.prevBtn ) {
				this.prevBtn.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					this.slide(-1);
				});
			}
			if ( this.nextBtn ) {
				this.nextBtn.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					this.slide(1);
				});
			}

			// Update arrow visibility on scroll
			if ( this.track ) {
				this.track.addEventListener('scroll', () => this._updateArrows(), { passive: true });
				requestAnimationFrame(() => this._updateArrows());
			}
		}

		slide(direction) {
			if ( ! this.track ) return;
			this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
		}

		_updateArrows() {
			if ( ! this.track || ! this.prevBtn || ! this.nextBtn ) return;
			const { scrollLeft, scrollWidth, clientWidth } = this.track;
			this.prevBtn.style.display = scrollLeft <= 2 ? 'none' : '';
			this.nextBtn.style.display = scrollLeft + clientWidth >= scrollWidth - 2 ? 'none' : '';
		}

		switchVariant(variantId) {
			const mappedId = this.variantMap[String(variantId)];
			if ( ! mappedId ) return;
			if ( mappedId === this.currentVariantId ) return;

			const template = this.querySelector(`template[data-variant-id="${mappedId}"]`);
			if ( ! template || ! this.track ) return;

			this.currentVariantId = mappedId;

			// Replace track content with new variant images
			this.track.innerHTML = '';
			this.track.appendChild(template.content.cloneNode(true));
			this.track.scrollLeft = 0;

			requestAnimationFrame(() => this._updateArrows());
		}

	}

	if ( typeof customElements.get('variant-gallery') == 'undefined' ) {
		customElements.define('variant-gallery', VariantGallery);
	}

}
